export const DRAFT_REPO = 'DRAFT_REPO';
export const DRAFT_SERVICE = 'DRAFT_SERVICE';
